module.exports = __webpack_public_path__ + "static/media/x-trail-side-3.c0a4ab82.jpg";